import { getOrThrow } from 'quartz/globalState/api';
import { COPILOT_LAYOUT_TYPE } from './globalState';
/**
 * Returns the name of the current package.
 *
 * @example
 * ```ts
 * import { getCopilotLayoutType } from 'quartz/framework/copilot/service';
 *
 * console.log(getCopilotLayoutType()); // 'sidebar'
 * ```
 */
export const getCopilotLayoutType = () => getOrThrow(COPILOT_LAYOUT_TYPE);